/**
 * 본문 양식 — **그리는 쪽이다.** 절 이름의 정본은 서버(`GET /tickets/meta`
 * 의 `templates`, 곧 `app/ticket_templates.py`)이고 여기는 그것을 본문 글자로
 * 편다. 화면에 한 벌 더 적으면 챗봇이 세운 초안과 사람이 누른 양식의 절
 * 이름이 갈린다.
 *
 * **빈 절을 걷는 것은 서버가 한다**(만들 때). 화면은 넣기만 한다.
 */

import type { TemplateSection } from '../api';

/** 빈 양식을 본문으로. 절마다 `## 제목` 한 줄과 빈 줄 하나. */
export function renderTemplate(sections: TemplateSection[]): string {
  return sections.map((s) => `## ${s.heading}\n`).join('\n');
}

/** 양식의 안내를 한 줄로 — 설명칸 placeholder 로 쓴다. */
export function templateHint(sections: TemplateSection[]): string {
  return sections.map((s) => `${s.heading}: ${s.hint}`).join(' · ');
}
